import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const BeigabenKundeServiceConfig = {
  name: "BeigabenKunde",
  annotations: []
} as ServiceConfig;